
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 381 308.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M332.5 157c10.2 10.2 16.1 23.6 16.6 38H98.4l.7 2.8c3.8 15.1.4 30.9-9.2 43.1-9.6 12.3-24 19.3-39.6 19.3-13.4 0-26.1-5.2-35.6-14.7C5.2 235.9 0 223.3 0 209.9c0-13.4 5.2-26.1 14.7-35.6s22.1-14.7 35.6-14.7h81.8l19.3-19.3h141c15.1 0 29.4 5.9 40.1 16.7zm-160.9 21.5c5-5 5-13.1 0-18-5-5-13.1-5-18 0-5 5-5 13.1 0 18 5 5 13.1 5 18 0zM50.3 242.1c17.8 0 32.2-14.5 32.2-32.2 0-8.6-3.4-16.7-9.4-22.8-6.1-6.1-14.2-9.4-22.8-9.4-17.8 0-32.2 14.5-32.2 32.2 0 8.6 3.4 16.7 9.4 22.8 6.1 6 14.2 9.4 22.8 9.4z"}}),_c('path',{attrs:{"d":"M235.6 276.4l-31.3-73.6H145l31.2 73.6z"}}),_c('path',{attrs:{"d":"M174.5 132.4l-13.6-32 2.8-.5c15.4-2.5 28.6-11.7 36.1-25.3 7.5-13.6 8.4-29.7 2.3-44-5.3-12.4-15-22-27.5-27s-26.1-4.9-38.5.3c-12.4 5.3-22 15-27 27.5s-4.9 26.1.3 38.5l30.1 70.9 8.5-8.5h26.5v.1zm-48.3-69.5c-6.9-16.4.7-35.3 17.1-42.3 7.9-3.4 16.7-3.4 24.7-.2s14.2 9.4 17.6 17.3c6.9 16.4-.7 35.3-17.1 42.3-7.9 3.4-16.7 3.4-24.7.2-8-3.2-14.3-9.3-17.6-17.3z"}}),_c('g',{staticClass:"cut-line"},[_c('path',{attrs:{"d":"M10.4 291.1h49.1v17.2H10.4z"}}),_c('path',{attrs:{"d":"M90.8 291.1h49.1v17.2H90.8z"}}),_c('path',{attrs:{"d":"M171.2 291.1h49.1v17.2h-49.1z"}}),_c('path',{attrs:{"d":"M251.6 291.1h49.1v17.2h-49.1z"}}),_c('path',{attrs:{"d":"M332 291.1h49.1v17.2H332z"}})])])
          )
        }
      }
    